import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
    container: {
        paddingHorizontal: 25,
        marginTop: 20,
        justifyContent: 'center'
    },
    description: {
        textAlign: 'justify',
        fontSize: 14,
        fontWeight: '400',
        lineHeight: 13
    },
    btnText: {
        fontSize: 18
    },
    btnAdd: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        height: 40,
        width: '100%',
        borderColor: '#32BFB1',
        borderWidth: 2,
        borderRadius: 20,
        marginTop: 20
    },

    contentBtn: {
        position: 'absolute',
        bottom: 60,
        paddingHorizontal: 25,
        width: '100%'
    },
    btn: {
        padding: 10,
        borderRadius: 20
    },
    textBtn: {
        color: '#fff',
        textAlign: 'center',
        fontSize: 18,
        fontWeight: '500'
    },
    contentBtnEmail: {
        position: 'absolute',
        bottom: 30,
        paddingHorizontal: 25,
        width: '100%'
    },
    textBtnEmail: {
        color: '#2C2C2E',
        textAlign: 'center',
        textDecorationLine: 'underline',
        fontWeight: 'normal'
    },
    centeredView: {
        flex: 1,
        justifyContent: "center",
        alignItems: "center",
        marginTop: 22,
    },
    modalCenteredView: {
        flex: 1,
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
    },
    closeModal: {
        marginLeft: "auto",
        marginRight: -20,
    },
    modalView: {
        width: "auto",
        marginTop: 20,
        backgroundColor: '#ffffff',
        borderRadius: 20,
        paddingHorizontal: 35,
        paddingVertical: 15,
        alignItems: "center",
        overflow: 'hidden',
        shadowOpacity: 0.2,
        shadowColor: '#000',
        shadowRadius: 0,
        shadowOffset: {
            width: 0,
            height: 0
        }
    },
});

export default styles;
